class CHProductSizeOverlay extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.ch-product-size-overlay__toggle');
    this.action = this.querySelector('[data-size-overlay-action]');
    this.status = this.querySelector('[data-size-overlay-status]');

    if (!this.button) return;

    this.handleToggle = (event) => {
      event.preventDefault();
      event.stopPropagation();

      const isOpen = this.dataset.state === 'open';
      const nextState = isOpen ? 'closed' : 'open';
      const summary = this.dataset.summary || 'Product dimensions';

      this.dataset.state = nextState;
      this.button.setAttribute('aria-pressed', String(!isOpen));
      this.button.setAttribute('aria-label', `${isOpen ? 'Show' : 'Hide'} product dimensions, ${summary}`);

      if (this.action) this.action.textContent = isOpen ? 'View size' : 'Hide size';
      if (this.status) this.status.textContent = isOpen ? 'Product dimensions hidden.' : `Product dimensions shown: ${summary}.`;
    };

    this.button.addEventListener('click', this.handleToggle);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleToggle);
  }
}

if (!customElements.get('ch-product-size-overlay')) {
  customElements.define('ch-product-size-overlay', CHProductSizeOverlay);
}
